import {feed_fetchFeedByContainer_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import React, {useContext, useMemo} from 'react'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {renderFeedItem} from 'views/MainPage/functions/renderFeedItem'
import UserContext from '../UserContext'
import {permissionCodes} from "../../../../modules/permissions/contants";
import PermissionProvider from "../../../../modules/permissions/PermissionProvider";
import {LoginContext} from "../../../../components/LoginContext";
import {renderIf} from "../../../Shared";
import GenericPostForm from "../../../../components/Feed/PostForm/GenericPostForm";

const UserNews = ({Wrapper = 'div'}) => {
    const {user: item} = useContext(UserContext)
    const login = useContext(LoginContext)

    const [id, prop] = [getId(item), getType(item)]

    const apiInfo = feed_fetchFeedByContainer_Api

    const lookupKey = useMemo(
        () => [apiInfo.path.replace(':id', id).replace(':prop', prop)].join('/'),
        [id, prop, apiInfo]
    )

    if (_.isEmpty(item)) return null

    console.log(111111, getId(item) === getId(login), login?.default_channel)
    return (
        <Wrapper className="space-y-3">
            {renderIf(
                getId(item) === getId(login),
                <PermissionProvider
                    permissions={{
                        [permissionCodes.canPost]: item,
                    }}>
                    <GenericPostForm container={{id, type: prop}} defaultChannel={login?.default_channel}/>
                </PermissionProvider>
            )}
            <EntityList
                apiInfo={apiInfo}
                lookupKey={lookupKey}
                query={bindQueryParams([{id}, {prop}])}
                renderItem={renderFeedItem}
                RenderEntity={React.Fragment}
                renderEmpty={() => (
                    <div className="w-full justify-center items-center">
                        <EmptyHolder/>
                    </div>
                )}
            />
        </Wrapper>
    )
}

export default UserNews
